module.exports = __webpack_public_path__ + "img/hq／pic.c60f64eb.png";